import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  styled,
  CardActionArea,
  CardMedia,
  Rating,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";
import { keyframes } from "@emotion/react";

// Define the keyframes for the scroll animation
// const scroll = keyframes`
//   0% { transform: translateX(-100%); }
//   100% { transform: translateX(0%); }
// `;

const scroll = keyframes`
from {transform: translateX(0%);}
to {transform: translateX(-50%);}
`;

// Create a styled Box for the scroller
const ScrollerBox = styled(Box)({
  display: "flex",
  overflowX: "hidden", // for scroll add : scroll or auto
  whiteSpace: "nowrap",
  animation: `${scroll} 60s linear infinite`,
  "&:hover": {
    animationPlayState: "paused",
  },
  // backgroundColor: "blue",
  padding: 2,
  width: "100%",
  marginTop: 5,
  marginBottom: 5,
  justifyContent: "center",
  alignItems: "center",

  "& > *": {
    // Direct children of ScrollerBox
    flexShrink: 0,
    "@media (max-width: 599px)": {
      // xtra-small devices
      width: "50%",
    },
    "@media (min-width: 600px) and (max-width: 959px)": {
      width: "75%",
      // minWidth: "300px",
    },
    "@media (min-width: 960px) and (max-width: 1279px)": {
      // width: "auto",
      width: "90%",
    },
  },
});

const ReviewCard = ({
  items,
}: {
  items: {
    description: string;

    ratings: number;
    user: {
      firstName: string;
      lastName: string;
      profileImage: string;
    };
  }[];
}) => {
  const defaultImage = "/assets/images/avatars/defaultUserImageForUs.avif";
  const clonedItems = [...items, ...items];
  return (
    <Box
      sx={{
        mx: "auto",
        position: "relative",
        display: "flex",
        zIndex: 20,
        overflowX: "auto",
        overflowY: "hidden",
        // backgroundColor: "red",
        width: "100%",
        height: 550,
      }}
    >
      <ScrollerBox>
        {clonedItems?.map((review, index) => (
          <Card
            sx={{
              margin: "0 10px",
              flexGrow: 0,

              width: {
                xs: "99%",
                sm: "99%",
                md: "25%",
                lg: "25%",
              },
              height: {
                xs: 520,
                sm: 550,
                md: 500,
              },
            }}
            key={index}
          >
            <CardActionArea>
              <CardMedia
                component="img"
                sx={{
                  height: {
                    xs: 245,
                    sm: 281,
                    md: 241,
                  },
                }}
                image={
                  review?.user?.profileImage
                    ? review?.user?.profileImage
                    : defaultImage
                }
                alt="profileImage"
              />
              <CardContent
                sx={{
                  height: 350,
                  overflow: "auto",
                  background:
                    "linear-gradient(180deg, var(--slate-800), var(--slate-900))", // Apply linear gradient background
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "16px",
                    lineHeight: 1.6,
                    fontWeight: 400,
                    maxWidth: "60ch",
                    color: "#fff",
                  }}
                >
                  {review?.description}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                  sx={{ mt: 2, color: "#fff" }}
                >
                  {`${review?.user?.firstName} ${review?.user?.lastName}`}
                </Typography>

                <Stack spacing={1} sx={{ bgcolor: "transparent" }}>
                  <Rating
                    name="half-rating-read"
                    value={review.ratings}
                    precision={0.5}
                    readOnly
                  />
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </ScrollerBox>
    </Box>
  );
};

ReviewCard.propTypes = {
  review: PropTypes.any,
};

export default ReviewCard;
